import { Flex } from "@gravity-ui/uikit";
import { ProductSourceDtoSourceEnum } from "definitions/product-storage";
import { DewuLogo, GoatLogo, PoizonComLogo } from "src/components/Icons";

interface SourcesCellProps {
  sources: ProductSourceDtoSourceEnum[];
}

export const SourcesCell = ({ sources }: SourcesCellProps) => {
  return (
    <Flex direction="row" gap="2" alignItems="center">
      {sources.includes("POIZON") && <PoizonComLogo />}
      {sources.includes("DEWU") && <DewuLogo />}
      {sources.includes("GOAT") && <GoatLogo />}
    </Flex>
  );
};
